import { useRef, useEffect, useState } from "react";

const BASE_CLASS = "filterableDropdown"

type FilterableDropdownProps = {
  allOptions: TSelectorOption[];
  onChangeIndex: Function;
}

export type TSelectorOption = {
  key: string;
  id: string;
  text: string;
  selected?: boolean
}

export const FilterableDropdown = ({ allOptions, onChangeIndex }: FilterableDropdownProps) => {
  const [search, setSearch] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState<TSelectorOption[]>([]);
  const [filteredOptions, setFilteredOptions] = useState(allOptions);
  const containerRef = useRef<HTMLDivElement>(null);

  // Filtrar opciones al escribir
  useEffect(() => {
    const lower = search.toLowerCase();
    setFilteredOptions(
      allOptions.filter(opt => opt.text.toLowerCase().includes(lower))
    );
  }, [search, allOptions]);

  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleSelection = (item: TSelectorOption) => {
    const isSelected = selectedItems.some(i => i.key === item.key);
    if (isSelected) {
      setSelectedItems(selectedItems.filter(i => i.key !== item.key));
      item.selected = false;
      onChangeIndex(item);      
    } else {
      setSelectedItems([...selectedItems, item]);
      item.selected = true;
      onChangeIndex(item);      
    }
  };

  const renderPlaceholder = () => {
    return selectedItems.length > 0
      ? selectedItems.length === 1
        ? selectedItems[0].text
        : "Múltiples índices seleccionados"
      : "Selecciona uno o varios índices"
  };

  return (
    <div className={BASE_CLASS}>
      <div className={`${BASE_CLASS}__container`} ref={containerRef}>
        <span className={`${BASE_CLASS}__indicesTitle`} >Índices</span>
        <div className={`${BASE_CLASS}__container__input`}>
          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onClick={() => setIsOpen(true)}
            placeholder={renderPlaceholder()}
            className={`${BASE_CLASS}__index__input`}
          />
          <i className={`${BASE_CLASS}__icon ironia-icon reports`} onClick={() => setIsOpen(true)}/>
        </div>
          
        {isOpen && (
          <div className={`${BASE_CLASS}__container__items`}>
            {filteredOptions.length > 0 ? (
              filteredOptions
                .sort((a, b) => {
                  const aSelected = selectedItems.some(i => i.key === a.key);
                  const bSelected = selectedItems.some(i => i.key === b.key);
                  return aSelected === bSelected ? 0 : aSelected ? -1 : 1;
                })
              .map((opt) => {
                const isChecked = selectedItems.some(i => i.key === opt.key);
                return (
                    <label
                      key={opt.key}
                      className={`${BASE_CLASS}__label`}
                    >
                      <input
                        type="checkbox"
                        checked={isChecked}
                        onChange={() => toggleSelection(opt)}
                        className={`${BASE_CLASS}__input__checkbox`}
                      />
                      {opt.text}
                    </label>
                );
              })
            ) : (
              <div className={`${BASE_CLASS}__notFound`}>No hay resultados</div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};